import React, { useCallback } from 'react';
import find from 'lodash/find';
import toString from 'lodash/toString';

import { IconsEnum } from '../../../../../assets/icons/types';
import { ClassName } from '../../../../../types';
import {
  UniversalFilterModeSelectOption,
  UniversalFilterModeSelectOnChange
} from './UniversalFilterModeSelect.types';

import { useDropdownState } from '../../../../../helpers/dropdowns/hooks/useDropdownState';

import { UniversalFilterSelectItem } from '../UniversalFilterSelectItem';

import { PureIconRefButtonHelper } from '../../../../../helpers/buttons/PureIconRefButtonHelper';
import { Popover } from '../../../../../helpers/Popover';

import { PopoverPlacement } from '../../../../../helpers/Popover/popoverConstants';

const dropdownMenuOffset = 12;

interface UniversalFilterModeSelectProps<T> {
  className: ClassName;
  selectedValue: T;
  options: UniversalFilterModeSelectOption<T>[];
  onChange: UniversalFilterModeSelectOnChange<T>;
}

function UniversalFilterModeSelect<T>({
  className,
  selectedValue,
  options,
  onChange
}: UniversalFilterModeSelectProps<T>) {
  const selectedOption = find(options, ['value', selectedValue]);

  const {
    isPopoverOpen,
    referencePopoverElement,
    referencePopoverCallbackRef,
    togglePopover,
    closePopover
  } = useDropdownState();

  const handleChange = useCallback<(value: T) => void>(
    (value) => {
      onChange(value);
      closePopover();
    },
    [onChange, closePopover]
  );
  return (
    <div className="relative">
      <PureIconRefButtonHelper
        className={className}
        icon={IconsEnum.CHEVRON_DOWN}
        iconClassName="h-4 w-4 shrink-0"
        iconPosition="right"
        i18nTextClassName=" "
        onClick={togglePopover}
        ref={referencePopoverCallbackRef}
        i18nText={selectedOption?.i18nText}
      />

      {isPopoverOpen ? (
        <Popover
          className="z-10 absolute w-full min-w-60 text-left bg-white dark:bg-gray-850 border border-gray-300 dark:border-gray-700 shadow-lg dark: dark:glow-md rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
          closePopover={closePopover}
          distanceOffset={dropdownMenuOffset}
          placement={PopoverPlacement.BOTTOM_START}
          referenceElement={referencePopoverElement}
          closeOnOuterClick
        >
          <ul>
            {options.map(({ value, i18nText }) => (
              <UniversalFilterSelectItem<T>
                key={toString(value)}
                value={value}
                i18nText={i18nText}
                isSelected={value === selectedValue}
                onChange={handleChange}
              />
            ))}
          </ul>
        </Popover>
      ) : null}
    </div>
  );
}

export default UniversalFilterModeSelect;
